import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { randomString } from '../../utils/string';
import { SwitchReturnType } from './switch.types';
import { switchProps } from './switch.utils';

@Component({
  selector: 'cohrex-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SwitchComponent implements OnChanges {
  props!: SwitchReturnType;

  private _color?: string = 'primary';
  @Input()
  set color(value: string | undefined) {
    this._color = value;
  }
  get color(): string | undefined {
    return this._color;
  }

  private _status?: boolean = false;
  @Input()
  set status(value: boolean | undefined) {
    this._status = value;
  }
  get status(): boolean | undefined {
    return this._status;
  }

  private _helperText?: string = '';
  @Input()
  set helperText(value: string | undefined) {
    this._helperText = value;
  }
  get helperText(): string | undefined {
    return this._helperText;
  }

  private _controlName?: string = '';
  @Input()
  set controlName(value: string | undefined) {
    this._controlName = value;
  }
  get controlName(): string | undefined {
    return this._controlName;
  }

  private _form?: FormGroup;
  @Input()
  set form(value: FormGroup | undefined) {
    this._form = value;
  }
  get form(): FormGroup | undefined {
    return this._form;
  }

  @Input() label: string = '';
  @Input() labelPosition: string = 'left';
  @Input() stackLabel: boolean = false;

  @Output()
  state = new EventEmitter<string>();

  switchIndex: string = '';

  get controlValue() {
    return this.form?.get(this.controlName as string)?.value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initProps();
    this.switchIndex = randomString();
  }

  initProps() {
    this.props = switchProps({
      color: this.color,
      switchStatus: this.status
    });
  }
}
